export default (variable) =>
  variable !== null && typeof variable === 'object' && !Array.isArray(variable);
